// extracted by mini-css-extract-plugin
module.exports = {"group":"RequestedMoney_group__2kE7Q"};